import { makeStore } from "@reciperoll/core";
import { webStorage } from "./webStorage";

// Web store: the shared factory from @reciperoll/core, persisted to IndexedDB via
// the localforage adapter. Data is populated by the sync engine (see src/sync)
// once signed in; nothing is seeded locally.
export const { store, persistor } = makeStore({ storage: webStorage });

export type { RootState, AppDispatch, AppStore } from "@reciperoll/core";
